import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';

const rules = ({ theme, color }) => ({
  background: theme.color[color],
  height: '100%',
  position: 'absolute',
});

function Fill(props) {
  const {
    color,
    left,
    width,
  } = props;
  const { css } = useFela({ color });

  return (
    <div
      className={css(rules, {
        left,
        width,
      })}
    />
  );
}

Fill.propTypes = {
  color: PropTypes.string.isRequired,
  left: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
};

export default React.memo(Fill);
